import React from 'react';
import { Icon } from '@gumtree/ui-library';
import LightBulb from '@gumtree/ui-library/src/assets/light-bulb.svg';
import { SearchButton, SearchButtonText, ServiceFormContainer, ServiceFormContent, InfoBox, InfoIcon, InfoText, ServiceFormButton } from './index.style';

interface Props {
    selectedService?: string;
    onSearchClick: () => void;
    onContinue: () => void;
}

const ServiceForm: React.FC<Props> = ({ selectedService, onSearchClick, onContinue }) => {
    const handleContinueClick = () => {
        if (selectedService && selectedService.trim() !== '') {
            onContinue();
        }
    };

    return (
        <ServiceFormContainer>
            <ServiceFormContent>
                <h2>What service are you looking for?</h2>
                <SearchButton type="button" onClick={onSearchClick}>
                    <Icon type="magnifying-glass" size="medium" />
                    <SearchButtonText>{selectedService || 'Search'}</SearchButtonText>
                </SearchButton>
                <InfoBox>
                    <InfoIcon><LightBulb /></InfoIcon>
                    <InfoText>Make one request and get quotes from up to 5 providers that match your schedule and budget.</InfoText>
                </InfoBox>
            </ServiceFormContent>
            <ServiceFormButton selectedService={selectedService}>
                <button type="button" onClick={handleContinueClick}>
                    Continue
                </button>
            </ServiceFormButton>
        </ServiceFormContainer>
    );
};

export default ServiceForm;
